module.exports = __webpack_public_path__ + "static/media/Thresh.88347776.png";